import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  Modal,
  Snackbar,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Close as CloseIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getOutletList } from "../../../services/outletApi";
import { updateData } from "../../../services/userManagementApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalChangeOutlet = ({ open, setOpen, data, id }) => {
  const [selectedOutlet, setSelectedOutlet] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const { mutate: mutateUpdateData } = useMutation({
    mutationFn: updateData,
    onSuccess: () => handleClose(),
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  const { data: dataOutlet, isFetching: isFetchingOutlet } = useQuery({
    queryFn: () => getOutletList(),
    queryKey: ["outlets"],
    refetchOnWindowFocus: false,
    enabled:
      open === true &&
      data &&
      data.status_code_user === 5 &&
      ![3, 4, 7, 11].includes(data.title_id),
  });

  useEffect(() => {
    if (data) setSelectedOutlet(data.outlets.map((item) => item.company_id));
  }, [data]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "70vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-1/3"
        >
          <div className="px-8 py-4 sticky top-0">
            <p className="font-bold text-[16px]">
              Silahkan pilih outlet yang ingin anda pakai
            </p>
          </div>

          <hr />

          <div className="max-h-[50vh] overflow-y-auto">
            {dataOutlet &&
            dataOutlet.filter((item) => item.is_assigned).length > 0 &&
            !isFetchingOutlet ? (
              dataOutlet
                .filter((item) => item.is_assigned)
                .map((item, i) => (
                  <div
                    className={`w-full px-4 py-2 ${i === 0 ? "" : "border-t"}`}
                  >
                    <FormControlLabel
                      sx={{
                        width: "100%",
                      }}
                      control={<Checkbox value={item.company_id} />}
                      label={item.company_name}
                      checked={selectedOutlet.includes(item.company_id)}
                      onChange={() => {
                        const index = selectedOutlet.findIndex(
                          (id) => id === item.company_id
                        );

                        setSelectedOutlet(
                          index < 0
                            ? [...selectedOutlet, item.company_id]
                            : [
                                ...selectedOutlet.slice(0, index),
                                ...selectedOutlet.slice(index + 1),
                              ]
                        );
                      }}
                    />
                  </div>
                ))
            ) : (
              <div className="flex items-center justify-center py-4">
                {isFetchingOutlet ? (
                  <CircularProgress size={20} />
                ) : (
                  "Anda tidak memiliki outlet, silahkan hubungi owner"
                )}
              </div>
            )}
          </div>
          <hr />
          <div className="flex items-center gap-4 px-8 py-2 sticky bottom-0 z-50">
            <button
              type="button"
              className="w-full rounded-md border-2 rounded hover:bg-gray-300 hover:text-white p-2 disabled:bg-gray-300 disabled:text-white"
              disabled={isFetchingOutlet}
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="w-full rounded-md bg-blue-500 text-white hover:bg-gray-300 p-2 disabled:bg-gray-300 disabled:text-white"
              disabled={isFetchingOutlet}
              onClick={() =>
                mutateUpdateData({
                  type: "outlet",
                  staff_id: parseInt(id, 10),
                  outlets: selectedOutlet,
                })
              }
            >
              Pilih Outlet
              {selectedOutlet.length > 0
                ? "(" + selectedOutlet.length + ")"
                : ""}
            </button>
          </div>
        </Box>
      </Modal>

      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={5000}
        onClose={() => setErrorMessage("")}
        message={errorMessage}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={(_, reason) => {
                if (reason === "clickaway") return;
                setErrorMessage("");
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />
    </>
  );
};

export default ModalChangeOutlet;
